import { ReturnChannel } from "../../models/returns/IReturnsApi";
import classNames from "../../utils/classNames";

export const CHANNEL_NAMES: Record<ReturnChannel, string> = { ebay: "eBay", partpro: "PartPro", counter: "Counter" };

const tagClasses: Record<ReturnChannel, string> = {
  ebay: "border border-gray-300 bg-white text-gray-900",
  partpro: "bg-gray-900 text-white",
  counter: "bg-gray-100 text-gray-700",
};

/** The channel as a small text badge (spec §9: channel badges are text). */
export default function ChannelTag({ channel, className }: { channel: ReturnChannel; className?: string }) {
  return <span className={classNames("inline-block shrink-0 rounded-[3px] px-1 text-[10px] font-bold leading-[16px]", tagClasses[channel], className)}>{CHANNEL_NAMES[channel]}</span>;
}
